import React, { Component } from 'react';
import Filter from './Filter';
import { Calender } from '../../shared-components';
import qs from 'qs';
import moment from 'moment';
import {
  TIME_CONSTANT,
  MAX_DAYS_FOR_TIME_CONSTANT_1_TICK_LABELS,
  MIN_DAYS_FOR_TIME_CONSTANT_7_TICK_LABELS,
  MAX_DAYS_FOR_TIME_CONSTANT_7_TICK_LABELS,
  MIN_DAYS_FOR_TIME_CONSTANT_14_TICK_LABELS,
  MAX_DAYS_FOR_TIME_CONSTANT_14_TICK_LABELS,
  MIN_DAYS_FOR_TIME_CONSTANT_90_TICK_LABELS,
  MAX_DAYS_FOR_TIME_CONSTANT_90_TICK_LABELS,
  COMPARE_CONTAINER_CLASS,
  COMPARE_BODY_CLASS,
  COMPARE_HEADER_CLASS,
  DASHBOARD_FILTER_LOCALSTORAGE,
  DISABLED_CLASS,
  BUTTON_COMPARE_CLASS,
  COMPARE_BODY_COMPARING,
  CATEGORY_LABEL_CLASS,
  CATEGORY_CONTAIN_TOPIC_CLASS,
  MAIN_TOPIC_NAME_CLASS,
  CHOOSE_TOPICS_COMPARE_TITLE,
  SPAN_EMPTY_CHECKBOX,
  COMPARE_TOPIC_CHECKBOX_CLASS,
  TITLE_CHOOSE_TOPIC_CLASS,
  CHECKBOX_TYPE,
  CHECKBOX_WITH_LABEL_CLASS,
  CHECKBOX_WITH_LABEL_CLASS_ACTIVE,
  MAXIMUM_SELECTED_TOPICS,
  DATE_TIME_IN_YYYY_MM_DD_FORMAT,
  TOPIC_COMPARE_CLASS,
  CHANGE_TOPIC_TEXT,
  TOPIC_COMPARED_TEXT,
  CHANGE_TOPIC_ACTION_CLASS,
  COMPARE_CHART_MAIN,
  COMPARE_CHART_LEGENDS,
  HIGH_CHART_CONTAINER_CLASS,
  TOPIC_NAME_FOR_TWO_CHARTS_CLASS,
  SPAN_BETWEEN_TWO_CHARTS,
  LIST_CHARTS,
} from './constants/CompareConstants';
import TitlesWithLineTypes from './compare/chart/TitlesWithLineTypes';
import CompareChartLegends from './compare/chart/CompareChartLegends';
import CompareChart from './compare/chart/CompareChart';
import ChartOfEachTopic from './compare/chart/CompareFeatureChartOfEachTopic.js';
import { TOTAL } from '../redux/constants';
export class Compare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tickInterval: 1000,
      dateRangeFilterValue: {},
      areMaximumNumberOfTopicsSelectedToCompare: false,
      selectedTopicIdsToCompare: [],
      selectedTopicNamesToCompare: [],
      topicId: [],
      isComparing: false,
      selectedSource: 'all sources',
      activeLabel: COMPARE_CHART_LEGENDS[0],
    };
    this.setActiveLabel = this.setActiveLabel.bind(this);
  }

  setActiveLabel(selectedLabel) {
    this.setState({
      activeLabel: selectedLabel,
    });
  }

  getDateRangeFilterValue() {
    const parsed = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    let filter = localStorage.getItem(DASHBOARD_FILTER_LOCALSTORAGE);
    if (parsed.fromDate && parsed.toDate) {
      const queryFilter = {
        fromDate: parsed['fromDate'],
        toDate: parsed['toDate'],
      };
      this.setDateRangeFilter(queryFilter);
    } else if (filter) {
      filter = JSON.parse(filter);
      if (filter.dateRangeFilterValue) {
        this.setState({
          dateRangeFilterValue: filter.dateRangeFilterValue,
          tickInterval: this.getTickInterval(filter.dateRangeFilterValue),
        });
      }
    } else {
      const newDateRangeFilterValue = {
        fromDate: moment()
          .subtract(6, 'days')
          .format(DATE_TIME_IN_YYYY_MM_DD_FORMAT),
        toDate: moment().format(DATE_TIME_IN_YYYY_MM_DD_FORMAT),
      };
      this.setState({
        dateRangeFilterValue: newDateRangeFilterValue,
        tickInterval: this.getTickInterval(newDateRangeFilterValue),
      });
    }
  }

  getTickInterval = dateTime => {
    const startDate = moment(dateTime.fromDate);
    const endDate = moment(dateTime.toDate);
    const diffDays = endDate.diff(startDate, 'days');
    if (diffDays === 0) {
      return TIME_CONSTANT / 4;
    } else if (diffDays < MAX_DAYS_FOR_TIME_CONSTANT_1_TICK_LABELS) {
      return TIME_CONSTANT;
    } else if (
      diffDays > MIN_DAYS_FOR_TIME_CONSTANT_7_TICK_LABELS &&
      diffDays < MAX_DAYS_FOR_TIME_CONSTANT_7_TICK_LABELS
    ) {
      return TIME_CONSTANT * 7;
    } else if (
      diffDays > MIN_DAYS_FOR_TIME_CONSTANT_14_TICK_LABELS &&
      diffDays < MAX_DAYS_FOR_TIME_CONSTANT_14_TICK_LABELS
    ) {
      return TIME_CONSTANT * 14;
    } else if (
      diffDays > MIN_DAYS_FOR_TIME_CONSTANT_90_TICK_LABELS &&
      diffDays < MAX_DAYS_FOR_TIME_CONSTANT_90_TICK_LABELS
    ) {
      return TIME_CONSTANT * 90;
    } else {
      return TIME_CONSTANT * 180;
    }
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      newProps.topicId.length &&
      JSON.stringify(newProps.topicId) !== JSON.stringify(this.state.topicId)
    ) {
      this.setState({
        topicId: newProps.topicId,
        areMaximumNumberOfTopicsSelectedToCompare: false,
        isComparing: false,
        selectedTopicIdsToCompare: [],
        selectedTopicNamesToCompare: [],
      });
    }
  }

  componentDidMount() {
    this.props.getCategories();
    this.getDateRangeFilterValue();
  }

  handleTopicChange(mouseEvent, topicId, topicName) {
    const newSelectedTopicData = this.generateNewDataForSeletedTopic(
      mouseEvent,
      topicId,
      topicName,
    );
    const areMaximumNumberOfTopicsSelectedToCompare = this.areMaximumNumberOfTopicsSelectedToCompare(
      newSelectedTopicData.topicId,
    );
    this.setState({
      areMaximumNumberOfTopicsSelectedToCompare: areMaximumNumberOfTopicsSelectedToCompare,
      selectedTopicIdsToCompare: newSelectedTopicData.topicId,
      selectedTopicNamesToCompare: newSelectedTopicData.topicName,
    });
  }

  generateNewDataForSeletedTopic(mouseEvent, topicId, topicName) {
    let newselectedTopicIdsToCompare = [];
    let newselectedTopicNamesToCompare = [];
    if (mouseEvent.target.checked) {
      newselectedTopicIdsToCompare = [...this.state.selectedTopicIdsToCompare, topicId];
      newselectedTopicNamesToCompare = [...this.state.selectedTopicNamesToCompare, topicName];
    } else {
      newselectedTopicIdsToCompare = this.state.selectedTopicIdsToCompare.filter(
        item => item !== topicId,
      );
      newselectedTopicNamesToCompare = this.state.selectedTopicNamesToCompare.filter(
        item => item !== topicName,
      );
    }
    return {
      topicId: newselectedTopicIdsToCompare,
      topicName: newselectedTopicNamesToCompare,
    };
  }

  areMaximumNumberOfTopicsSelectedToCompare(selectedTopicIdsToCompare) {
    return selectedTopicIdsToCompare.length === MAXIMUM_SELECTED_TOPICS;
  }

  shouldCheckboxForTopicBeDisabled(id) {
    if (this.state.selectedTopicIdsToCompare.includes(id)) {
      return false;
    } else {
      return this.state.areMaximumNumberOfTopicsSelectedToCompare;
    }
  }

  getCheckboxWithLabelClassName(id) {
    const isDisabled = this.shouldCheckboxForTopicBeDisabled() ? DISABLED_CLASS : '';
    if (this.state.selectedTopicIdsToCompare.includes(id) || this.state.topicId[0] === id) {
      return CHECKBOX_WITH_LABEL_CLASS_ACTIVE;
    } else {
      return CHECKBOX_WITH_LABEL_CLASS + isDisabled;
    }
  }

  shouldCheckboxForTopicBeChecked(topicId) {
    if (this.state.selectedTopicIdsToCompare.length) {
      if (this.state.selectedTopicIdsToCompare.includes(topicId)) {
        return true;
      }
    }
    return false;
  }

  renderCheckboxForTopic(topic) {
    if (this.state.topicId[0] !== topic.topicId) {
      return (
        <input
          className={COMPARE_TOPIC_CHECKBOX_CLASS}
          type={CHECKBOX_TYPE}
          onChange={e => this.handleTopicChange(e, topic.topicId, topic.topicName)}
          disabled={this.shouldCheckboxForTopicBeDisabled(topic.topicId)}
          checked={this.shouldCheckboxForTopicBeChecked(topic.topicId)}
        />
      );
    } else {
      return <span className={SPAN_EMPTY_CHECKBOX}></span>;
    }
  }
  isTooFewSelectedTopicsToCompare() {
    return this.state.selectedTopicIdsToCompare.length <= 0;
  }

  renderChooseTopic() {
    return (
      <div>
        {this.renderTopicCompareTitleAndMainTopicName()}
        {this.renderChooseTopicWithEachCategory()}
        {this.renderButtonCompare()}
      </div>
    );
  }

  renderTopicCompareTitleAndMainTopicName() {
    return (
      <React.Fragment>
        <p className={TITLE_CHOOSE_TOPIC_CLASS}>{CHOOSE_TOPICS_COMPARE_TITLE}</p>
        <p className={MAIN_TOPIC_NAME_CLASS}>{this.getMainTopicName()}</p>
      </React.Fragment>
    );
  }

  renderChooseTopicWithEachCategory() {
    return (
      <div>
        {JSON.parse(JSON.stringify(this.props.categories)).map(item => {
          return (
            <div className={CATEGORY_CONTAIN_TOPIC_CLASS} key={item.categoryName}>
              <p className={CATEGORY_LABEL_CLASS}>{item.categoryName}</p>
              {this.renderEachTopicNameWithCheckbox(item)}
            </div>
          );
        })}
      </div>
    );
  }

  renderEachTopicNameWithCheckbox(item) {
    return item.topics.map(topic => {
      return (
        <div className={this.getCheckboxWithLabelClassName(topic.topicId)} key={topic.topicId}>
          {this.renderCheckboxForTopic(topic)}
          <p>{topic.topicName}</p>
        </div>
      );
    });
  }

  handleChangeCompareState() {
    this.setState(
      {
        isComparing: !this.state.isComparing,
      },
      () => {
        if (this.state.isComparing) {
          this.getDataToCompare();
        }
      },
    );
  }

  getDataToCompare() {
    this.props.getCompareData({
      topicId: [...this.state.topicId, ...this.state.selectedTopicIdsToCompare],
      dateRangeFilterValue: this.state.dateRangeFilterValue,
      selectedSource: this.state.selectedSource,
    });
  }

  renderComparing() {
    const allTopicNames = [this.getMainTopicName(), ...this.state.selectedTopicNamesToCompare];
    return (
      <div className={COMPARE_BODY_COMPARING}>
        {this.renderTopicCompareTextAndChangeTopicAction()}
        {this.renderTitlesWithLineTypes(allTopicNames)}
        {this.renderCompareChartMain(allTopicNames)}
      </div>
    );
  }

  getMainTopicName() {
    const topics = JSON.parse(JSON.stringify(this.props.categories))
      .map(categories => {
        return categories.topics;
      })
      .flat();
    const mainTopic = topics.find(item => item.topicId === this.state.topicId[0]);
    if (mainTopic) {
      return mainTopic.topicName;
    }
  }
  renderTopicCompareTextAndChangeTopicAction() {
    return (
      <p className={TOPIC_COMPARE_CLASS}>
        {TOPIC_COMPARED_TEXT}
        <span>
          <u className={CHANGE_TOPIC_ACTION_CLASS} onClick={() => this.handleChangeCompareState()}>
            {CHANGE_TOPIC_TEXT}
          </u>
        </span>
      </p>
    );
  }

  renderTitlesWithLineTypes(allTopicNames) {
    return (
      <TitlesWithLineTypes
        selectedTopicNamesToCompare={allTopicNames}
        color={this.state.activeLabel.color}
      ></TitlesWithLineTypes>
    );
  }

  renderCompareChartMain(allTopicNames) {
    return (
      <div className={COMPARE_CHART_MAIN}>
        {this.renderCompareChartLegends()}
        {this.renderAllCharts(allTopicNames)}
      </div>
    );
  }

  renderCompareChartLegends() {
    return (
      <CompareChartLegends
        compareChartLegends={COMPARE_CHART_LEGENDS}
        setActiveLabel={this.setActiveLabel}
        activeLabel={this.state.activeLabel}
      ></CompareChartLegends>
    );
  }
  renderAllCharts(allTopicNames) {
    return (
      <div className={HIGH_CHART_CONTAINER_CLASS}>
        {this.renderCompareChart(allTopicNames)}
        {this.renderTwoChartsForEachTopic(allTopicNames)}
      </div>
    );
  }

  renderCompareChart(allTopicNames) {
    return (
      <CompareChart
        tickInterval={this.state.tickInterval}
        dateRangeFilterValue={this.state.dateRangeFilterValue}
        activeLabel={this.state.activeLabel}
        topicCompareData={this.props.topicCompareData}
        selectedTopicsName={allTopicNames}
      ></CompareChart>
    );
  }

  renderSentimentChart(allTopicNames, index, allTopicIds) {
    return (
      <ChartOfEachTopic
        data={this.getSentimentChartData(allTopicNames, index)}
        title={LIST_CHARTS.sentiment.name}
        chartId={LIST_CHARTS.sentiment.id}
        chartType={LIST_CHARTS.sentiment.chartType}
        selectedTopicId={allTopicIds[index]}
        source={[...this.state.selectedSource]}
        dateRangeFilterValue={this.state.dateRangeFilterValue}
      />
    );
  }

  renderEmotionChart(allTopicNames, index, allTopicIds) {
    return (
      <ChartOfEachTopic
        data={this.getEmotionChartData(allTopicNames, index)}
        title={LIST_CHARTS.emotion.name}
        chartId={LIST_CHARTS.emotion.id}
        selectedTopicId={allTopicIds[index]}
        chartType={LIST_CHARTS.emotion.chartType}
        source={[...this.state.selectedSource]}
        dateRangeFilterValue={this.state.dateRangeFilterValue}
      />
    );
  }

  renderTwoChartsForEachTopic(allTopicNames) {
    const allTopicIds = [...this.state.topicId, ...this.state.selectedTopicIdsToCompare];
    return allTopicNames.map((topicName, index) => {
      return (
        <div key={topicName}>
          <p className={TOPIC_NAME_FOR_TWO_CHARTS_CLASS}>{topicName}</p>
          {this.renderSentimentChart(allTopicNames, index, allTopicIds)}
          <div className={SPAN_BETWEEN_TWO_CHARTS}></div>
          {this.renderEmotionChart(allTopicNames, index, allTopicIds)}
        </div>
      );
    });
  }

  getEmotionChartData(allTopicNames, index) {
    if (this.props.topicCompareData.length === allTopicNames.length) {
      return this.props.topicCompareData[index][1];
    } else {
      return [];
    }
  }

  getSentimentChartData(allTopicNames, index) {
    if (this.props.topicCompareData.length === allTopicNames.length) {
      const data = this.props.topicCompareData[index][0];
      return data.filter(item => item.category !== TOTAL);
    } else {
      return [];
    }
  }

  renderButtonCompare() {
    return (
      <button
        onClick={() => this.handleChangeCompareState()}
        className={`${BUTTON_COMPARE_CLASS} ${
          this.isTooFewSelectedTopicsToCompare() ? DISABLED_CLASS : ''
        }`}
      >
        Compare
      </button>
    );
  }

  filterBySource = selectedSource => {
    if (selectedSource.length) {
      this.setState({ selectedSource }, () => {
        let filter = localStorage.getItem(DASHBOARD_FILTER_LOCALSTORAGE);
        filter =
          filter && filter.length
            ? { ...JSON.parse(filter), ...{ source: this.state.selectedSource } }
            : { source: this.state.selectedSource };
        localStorage.setItem(DASHBOARD_FILTER_LOCALSTORAGE, JSON.stringify(filter));
        this.getDataToCompare();
      });
    } else {
      let filter = localStorage.getItem(DASHBOARD_FILTER_LOCALSTORAGE);
      if (filter) {
        filter = JSON.parse(filter);
        if (filter.source) {
          delete filter.source;
        }
        localStorage.setItem(DASHBOARD_FILTER_LOCALSTORAGE, JSON.stringify(filter));
      }
    }
  };

  setDateRangeFilter = dateRangeFilterValue => {
    this.setState(
      {
        dateRangeFilterValue,
      },
      () => {
        this.getDataToCompare();
      },
    );
  };

  renderCompareHeader() {
    const { sourcesFilter } = this.props;
    const updatedSourcesFilter = JSON.parse(JSON.stringify(sourcesFilter)).map(source => {
      source.checked = true;
      return source;
    });
    return (
      <div className={COMPARE_HEADER_CLASS}>
        {updatedSourcesFilter.length > 0 && (
          <Filter
            sourcesFilter={[...updatedSourcesFilter]}
            filterBySource={e => this.filterBySource(e)}
          />
        )}
        <Calender setDateRange={e => this.setDateRangeFilter(e)} />
      </div>
    );
  }

  renderCompareBody() {
    return (
      <div className={COMPARE_BODY_CLASS}>
        {this.state.isComparing ? this.renderComparing() : this.renderChooseTopic()}
      </div>
    );
  }

  render() {
    return (
      <div className={COMPARE_CONTAINER_CLASS}>
        {this.renderCompareHeader()}
        {this.renderCompareBody()}
      </div>
    );
  }
}
export default Compare;



// WEBPACK FOOTER //
// ./src/features/home/components/Compare.js